import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationPredefinedFiltersRepository } from '../../../infrastructure/repositories/investigation-predefined-filters.repository';
import { GetInvestigationPredefinedFiltersResult } from './get-investigation-predefined-filters.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationPredefinedFiltersUseCase {
  private readonly _repository = inject(InvestigationPredefinedFiltersRepository);

  public execute(): Observable<GetInvestigationPredefinedFiltersResult> {
    return this._repository.getPredefinedFilters().pipe(
      map((predefinedFilters) => ({ predefinedFilters })),
    );
  }
}
